import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import {MsalService} from "@azure/msal-angular";

@Component({
    selector: 'app-notif-connexion',
    templateUrl: './notif-connexion.component.html',
    styleUrls: ['./notif-connexion.component.scss'],
    imports: [MatDialogContent, RouterLink, MatDialogActions]
})
export class NotifConnexionComponent {
    private readonly modal = inject<MatDialogRef<NotifConnexionComponent>>(MatDialogRef);
    private readonly msalService = inject(MsalService);


    onOkClick() {
        this.modal.close();
    }

    goToConnexion() {
        this.msalService.logout();
        this.modal.close();
    }
}
